export default __webpack_public_path__ + "static/media/job_offer4_m.b03d3a06.jpg";